import Vue from 'vue';
import product from './Product';

const products = Vue.component('fl-products', {
    template: `
      <div v-if="config.blocks.product" class="fl-as-products-wrapper fl-position-relative fl-p-10">
        <template v-if="products.length > 0">
          <fl-product
              v-for="product in products.slice(0, 8)"
              :key="product.id"
              :product="product"
          />
        </template>
        <div v-if="products.length === 0">
          <div class="fl-as-product-empty fl-as-product-container fl-w-100"></div>
        </div>
      </div>`,
    props: {
        products: Array,
    },
    inject: ['config'],
    components: {
        Product: product,
    },
});

export default products;
